import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Login from "@/pages/Login";
import Game from "@/pages/Game";
import AuthCallback from "@/pages/AuthCallback";
import ResetPassword from "@/pages/ResetPassword";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";

function ProtectedGame() {
  const { user, checked, logout } = useAuth();
  if (!checked || user === null) {
    return (
      <div className="min-h-screen w-full bg-[#050505] text-white flex items-center justify-center">
        <div className="mono text-[12px] uppercase tracking-widest text-zinc-500">
          Connecting…
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Game user={user} onLogout={logout} />;
}

function AppRouter() {
  const location = useLocation();
  const { user, checked } = useAuth();
  // Synchronous capture of session_id fragment from Emergent Google redirect.
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  // Password reset link lands here with `?reset_token=...`. Render the
  // dedicated reset page (works whether the user is signed-in or not — the
  // backend re-issues a fresh JWT on success regardless).
  const params = new URLSearchParams(location.search);
  const resetToken = params.get("reset_token");
  if (resetToken) {
    return <ResetPassword token={resetToken} />;
  }
  return (
    <Routes>
      <Route path="/" element={<ProtectedGame />} />
      <Route
        path="/login"
        element={checked && user ? <Navigate to="/" replace /> : <Login />}
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App h-full">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}

export default App;
